const youtube = {
  data() {
    return {
      youtubeEmbedLink: 'https://www.youtube.com/embed/',
    };
  },
  methods: {
    getYouTubeID(url) {
      let src = '';
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/; // eslint-disable-line
      const match = url.match(regExp);
      if (match && match[2].length === 11) {
        src = match[2];
      }
      return src;
    },
  },
};

module.exports = {
  youtube,
};



// WEBPACK FOOTER //
// ./src/mixins/youtube.js